import { render, staticRenderFns } from "./SetProductDetails.vue?vue&type=template&id=d4351a9a&scoped=true&"
import script from "./SetProductDetails.vue?vue&type=script&lang=js&"
export * from "./SetProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetProductDetails.vue?vue&type=style&index=0&id=d4351a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4351a9a",
  null
  
)

export default component.exports